<script lang="ts" setup>
type Props = {
  color?: string;
};

withDefaults(defineProps<Props>(), {
  color: "#000",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="45"
    viewBox="0 0 44 45"
    fill="none"
  >
    <rect
      x="0.5"
      y="-0.5"
      width="43"
      height="43"
      rx="21.5"
      transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 -4.37114e-08 43.0203)"
      :stroke="color"
    />
    <path
      d="M13.4697 21.4899C13.1768 21.7828 13.1768 22.2577 13.4697 22.5506L18.2426 27.3236C18.5355 27.6165 19.0104 27.6165 19.3033 27.3236C19.5962 27.0307 19.5962 26.5558 19.3033 26.2629L15.0607 22.0203L19.3033 17.7776C19.5962 17.4847 19.5962 17.0099 19.3033 16.717C19.0104 16.4241 18.5355 16.4241 18.2426 16.717L13.4697 21.4899ZM30.5 22.7703C30.9142 22.7703 31.25 22.4345 31.25 22.0203C31.25 21.6061 30.9142 21.2703 30.5 21.2703L30.5 22.7703ZM14 22.7703L30.5 22.7703L30.5 21.2703L14 21.2703L14 22.7703Z"
      :fill="color"
    />
  </svg>
</template>
